<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->
          <div class="card main-card">
            <div class="card-body">
              <!-- Search -->
              <div class="search-section">
                <div class="row align-items-center">
                  <div class="col-xl-6 col-xxl-4">
                    <div class="row align-items-center">
                      <div class="col-md-5">
                        <div class="form-wrap icon-form mb-1 info-container">
                          <span class="form-icon"><i class="ti ti-search"></i></span>
                          <!-- <input type="text" class="form-control"
                            placeholder="Search by org name, contract number, or contract description"
                            v-model="searchQuery" @input="searchContracts(1)" /> -->
                          <input type="text" class="form-control"
                            placeholder="Search by org name, contract number, or contract description"
                            v-model="searchQuery" @input="debouncedSearchContracts(1)" />
                          <i class="ti ti-info-circle info-icon" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Search by Organisation name, Opportunity number, Contract number"></i>
                        </div>
                      </div>
                      <div class="col-md-7"
                        v-if="['company_admin', 'territory_manager', 'cm_responsible'].some(role => user.roles.includes(role))">
                        <user-filters :from="'contract'" @filterData="searchContracts"></user-filters>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-xxl-4">
                    <div class="row">
                      <div class="col-md-6"
                        v-if="['company_admin', 'territory_manager'].some(role => user.roles.includes(role))">
                        <div class="form-wrap mb-3">
                          <label class="col-form-label filter-lable">CM Responsible </label>
                          <!-- <Field as="select" name="cm_responsible" class="form-select form-select-height"
                            v-model="filters.cm_responsible" @change="responsibleFilter">
                            <option value="">All</option>
                            <option v-for="res in cmResponsibleOptions" :key="res.id" :value="res.id">
                              {{ res.name }}
                            </option>
                          </Field> -->

                          <!-- <vue-select :options="cmResponsibleOptions" v-model="filters.cm_responsible"
                            :settings="{ multiple: true, placeholder: 'All' }" placeholder="All"
                            @select="responsibleFilter($event, 'cm_responsible')" autocomplete="off" autocorrect="off"
                            autocapitalize="off" spellcheck="false" /> -->

                          <div class="dropdown ms-1">
                            <button class="form-select text-start" type="button" id="dropdownMenuButton1"
                              data-bs-toggle="dropdown" aria-expanded="false">
                              <strong class="">CM</strong>
                            </button>
                            <div class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton1">
                              <div class="border-bottom p-2">
                                <input type="text" class="form-control" placeholder="Search..." v-model="searchCM" />
                              </div>
                              <ul class="user_list">
                                <!-- Select All Checkbox -->
                                <li class="dropdown-item border-bottom d-flex align-items-center">
                                  <label class="d-flex align-items-center w-100 mb-0">
                                    <input type="checkbox" :checked="isAllSelectedCm" @change="toggleSelectAllCM" />
                                    <span class="ms-2 text-capitalize">Select All</span>
                                  </label>
                                </li>

                                <!-- <li class="dropdown-item border-bottom d-flex">
                                  <input type="checkbox" id="select-all1" :checked="isAllSelectedCm"
                                    @change="toggleSelectAllCM" />
                                  <label class="ms-2 text-capitalize d-flex" for="select-all1">
                                    Select All</label>
                                </li> -->

                                <!-- <li class="dropdown-item border-bottom d-flex" @click="toggleSelectAllCM">
                                  <input type="checkbox" id="select-all" :checked="isAllSelectedCm" @click.stop />
                                  <label class="ms-2 text-capitalize d-flex" for="select-all">
                                    Select All
                                  </label>
                                </li> -->


                                <!-- User List -->
                                <li v-for="user in filteredUsersCm" :key="user.id"
                                  class="dropdown-item border-bottom d-flex align-items-center">
                                  <label class="d-flex align-items-center w-100 mb-0">
                                    <input type="checkbox" :value="user.id" v-model="filters.cm_responsible"
                                      @change="searchContracts" />
                                    <span class="ms-2 text-capitalize">
                                      {{ user.first_name }} {{ user.last_name }}
                                    </span>
                                  </label>
                                </li>

                                <!-- <li v-for="user in filteredUsersCm" :key="user.id"
                                  class="dropdown-item border-bottom d-flex">
                                  <input type="checkbox" :value="user.id" :id="user.id" v-model="filters.cm_responsible"
                                    @change="searchContracts" />
                                  <label class="ms-2 text-capitalize d-flex">
                                    {{ user.first_name }} {{ user.last_name }}
                                  </label>
                                </li> -->

                                <!-- <li v-for="user in filteredUsersCm" :key="user.id"
                                  class="dropdown-item border-bottom d-flex" @click="toggleCheckboxCm(user.id)">
                                  <input type="checkbox" :value="user.id" :id="user.id" v-model="filters.cm_responsible"
                                    @click.stop />
                                  <label class="ms-2 text-capitalize d-flex" :for="user.id">
                                    {{ user.first_name }} {{ user.last_name }}
                                  </label>
                                </li> -->

                              </ul>
                            </div>
                          </div>

                        </div>
                      </div>
                      <!-- <div class="col-md-4">
                        <div class="form-wrap mb-3">
                          <label class="col-form-label filter-lable">Sales responsible </label>
                          <div class="dropdown ms-1">
                            <button class="form-select text-start" type="button" id="dropdownMenuButton2"
                              data-bs-toggle="dropdown" aria-expanded="false">
                                 <strong class="">SR</strong>
                            </button>
                            <div class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton2">
                              <div class="border-bottom p-2">
                                <input type="text" class="form-control" placeholder="Search..." v-model="searchSales" />
                              </div>
                              <ul class="user_list">

                                <li class="dropdown-item border-bottom d-flex align-items-center">
                                  <label class="d-flex align-items-center w-100 mb-0">
                                    <input type="checkbox" :checked="isAllSelectedSales"
                                      @change="toggleSelectAllSales" />
                                    <span class="ms-2 text-capitalize">Select All</span>
                                  </label>
                                </li>

                                <li v-for="user in filteredUsersSales" :key="user.id"
                                  class="dropdown-item border-bottom d-flex align-items-center">
                                  <label class="d-flex align-items-center w-100 mb-0">
                                    <input type="checkbox" :value="user.id" v-model="filters.sales_responsible"
                                      @change="searchContracts()" />
                                    <span class="ms-2 text-capitalize">{{ user.name }}</span>
                                  </label>
                                </li>

                              </ul>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="col-md-6">
                        <div class="form-wrap mb-3">
                          <label class="col-form-label filter-lable">U4B Status</label>
                          <!-- <Field as="select" name="u4b_status" class="form-select form-select-height"
                            v-model="filters.u4b_status" @change="responsibleFilter">
                            <option value="">All</option>
                            <option v-for="res in contractOptions.contract_u4b_status" :key="res.value"
                              :value="res.value">
                              {{ res.text }}
                            </option>
                          </Field> -->
                          <!-- <vue-select :options="contractOptions" v-model="filters.u4b_status"
                            :settings="{ multiple: true, placeholder: 'All' }" placeholder="All"
                            @select="responsibleFilter($event, 'u4b_status')" autocomplete="off" autocorrect="off"
                            autocapitalize="off" spellcheck="false" /> -->

                          <div class="dropdown ms-1">
                            <button class="form-select text-start" type="button" id="dropdownMenuButton3"
                              data-bs-toggle="dropdown" aria-expanded="false">
                              <!-- +<i class="ion-person"></i> --><strong class="">U4B</strong>
                            </button>
                            <div class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton3">
                              <div class="border-bottom p-2">
                                <input type="text" class="form-control" placeholder="Search..." v-model="searchU4b" />
                              </div>
                              <ul class="user_list">
                                <!-- Select All Checkbox -->

                                <li class="dropdown-item border-bottom d-flex align-items-center">
                                  <label class="d-flex align-items-center w-100 mb-0">
                                    <input type="checkbox" :checked="isAllSelectedU4b" @change="toggleSelectAllU4b" />
                                    <span class="ms-2 text-capitalize">Select All</span>
                                  </label>
                                </li>


                                <!-- <li class="dropdown-item border-bottom d-flex" @click="toggleSelectAllU4b">
                                  <input type="checkbox" id="select-all3" :checked="isAllSelectedU4b" @click.stop />
                                  <label class="ms-2 text-capitalize d-flex" for="select-all3">
                                    Select All
                                  </label>
                                </li> -->

                                <!-- User List -->
                                <li v-for="user in filteredUsersU4b" :key="user.value"
                                  class="dropdown-item border-bottom d-flex align-items-center">
                                  <label class="d-flex align-items-center w-100 mb-0">
                                    <input type="checkbox" :value="user.value" v-model="filters.u4b_status"
                                      @change="searchContracts()" />
                                    <span class="ms-2 text-capitalize">{{ user.text }}</span>
                                  </label>
                                </li>

                                <!-- <li v-for="user in filteredUsersU4b" :key="user.value"
                                  class="dropdown-item border-bottom d-flex">
                                  <input type="checkbox" :value="user.value" :id="user.value"
                                    v-model="filters.u4b_status" @change="searchContracts()" />
                                  <label class="ms-2 text-capitalize d-flex">
                                    {{ user.text }}
                                  </label>
                                </li> -->

                                <!-- <li v-for="user in filteredUsersU4b" :key="user.value"
                                  class="dropdown-item border-bottom d-flex" @click="toggleCheckboxU4b(user.value)">
                                  <input type="checkbox" :value="user.value" :id="user.value" v-model="filters.u4b_status"
                                    @click.stop />
                                  <label class="ms-2 text-capitalize d-flex" :for="user.value">
                                    {{ user.text }}
                                  </label>
                                </li> -->

                              </ul>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12 col-xxl-4 mb-xl-3">
                    <div class="export-list text-xl-end mb-3 mb-lg-2 mb-xl-0">
                      <ul class="row-gap-2">
                        <li class="days-filters-row mb-0 days-filters-list">
                          <div id="toggle-filter" class="toggle-filter">
                            <span :class="{ active: isActive === 'All' }" @click="toggleFilter('All')">
                              All
                            </span>
                            <span :class="{ active: isActive === '365' }" @click="toggleFilter('365')">
                              365 (Days)
                            </span>
                          </div>
                        </li>

                        <li class="days-filters-row mb-0">
                          <div class="filter-set-view toggle-filter" ref="dropdown">
                            <div class="filter-set-head filter-btn">
                              <button @click.prevent="toggleAccordion" class="btn btn-light toggle-btn"><i
                                  class="ti ti-list-tree me-2"></i>Contents</button>
                              <div class="accordion filter-drop-down" id="accordionContract" v-if="showAccordion">
                                <div class="filter-set-content">
                                  <div class="filter-set-contents accordion-collapse collapse show"
                                    id="collapseContract" data-bs-parent="#accordionContract">
                                    <div class="filter-content-list">
                                      <div class="form-wrap icon-form">
                                        <span class="form-icon"><i class="ti ti-search me-2"></i></span>
                                        <input type="text" class="form-control" placeholder="Search Columns"
                                          v-model="searchTerm" />
                                      </div>
                                      <ul>
                                        <li v-for="colName in filteredColumnOptions" :key="colName.value">
                                          <div class="filter-checks">
                                            <label class="checkboxs"
                                              :class="{ 'disabled-label': selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value) }"
                                              @click.prevent="handleColumnSelection(colName.value)">
                                              <input type="checkbox" class="disabled-checkbox"
                                                :id="'checkbox-' + colName.value"
                                                :checked="selectedColumns.value.includes(colName.value)"
                                                :disabled="selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value)"
                                                @click.stop />
                                              <span class="checkmarks"></span>
                                            </label>
                                          </div>
                                          <div class="collapse-inside-text">
                                            <h5 :for="'checkbox-' + colName.value"
                                              @click="handleColumnSelection(colName.value)"
                                              :class="{ 'disabled-label': selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value) }">
                                              {{ colName.label }}
                                            </h5>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li class="mb-0">
                          <router-link to="/crm/create-contract" class="btn btn-primary"><i
                              class="ti ti-square-rounded-plus"></i>Add</router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Search -->

              <!-- Filter -->
              <!-- <contracts-filter></contracts-filter> -->
              <!-- /Filter -->

              <!-- Projects List -->
              <div class="table-responsive custom-table">
                <contracts-table :search-query="searchQuery" :date_range="isActive" :filterData="filteredFilters"
                  :moduleId="moduleId" :selectedColumns="selectedColumns" :columnOptions="columnOptions"
                  ref="contractsTable"></contracts-table>
              </div>
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="datatable-length"></div>
                </div>
                <div class="col-md-6">
                  <div class="datatable-paginate"></div>
                </div>
              </div>
              <!-- /Projects List -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <contracts-modal></contracts-modal>
</template>
<script>
import {
  ref, computed, onMounted, onBeforeUnmount, nextTick
} from 'vue';
import {
  useStore
} from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
import {
  Form,
  Field,
  ErrorMessage
} from "vee-validate";
const rowSelection = {
  onChange: () => { },
  onSelect: () => { },
  onSelectAll: () => { },
};
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      rowSelection,
      title: "Contracts",
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const user = computed(() => store.getters['auth/user']);
    const searchQuery = ref(""); // Example: For holding search query input
    const filters = ref({
      cm_responsible: [],
      u4b_status: [],
    });
    const shouldPassFilter = computed(() =>
      ['company_admin', 'territory_manager', 'cm_responsible'].some(role => user.value.roles.includes(role))
    );

    const filteredFilters = computed(() => {
      const baseFilters = {
        u4b_status: filters.value.u4b_status,
      };

      if (shouldPassFilter.value) {
        return {
          ...baseFilters,
          cm_responsible: filters.value.cm_responsible,
        };
      }

      return baseFilters;
    });

    const contractsTable = ref(null);
    const isActive = ref(localStorage.getItem('contract365') || "All");

    const searchCM = ref("");
    const searchU4b = ref("");
    const checkedIdsCm = ref([]);
    const checkedIdsU4b = ref([]);
    const isAllSelectedCm = computed(() => filters.value.cm_responsible.length === filteredUsersCm.value.length)
    const isAllSelectedU4b = computed(() => filters.value.u4b_status.length === filteredUsersU4b.value.length)

    const cmData = ref([]);
    const srData = ref([]);
    const u4bData = ref([]);

    const filteredUsersCm = computed(() => {
      if (!searchCM.value) return cmData.value;
      return cmData.value.filter((user) =>
        user.first_name?.toLowerCase().includes(searchCM.value.toLowerCase()) ||
        user.last_name?.toLowerCase().includes(searchCM.value.toLowerCase())
      );
    });

    const filteredUsersU4b = computed(() => {
      if (!searchU4b.value) return u4bData.value;
      return u4bData.value.filter((user) =>
        user.text?.toLowerCase().includes(searchU4b.value.toLowerCase())
      );
    });

    const toggleFilter = (value) => {
      isActive.value = value;
      localStorage.setItem('contract365', value)
      setTimeout(() => {
        searchContracts();
      }, 0);
    };

    const searchContracts = (page=1) => {
      if (contractsTable.value) {
        contractsTable.value.fetchContracts(page);
      }
    };

    // ===== Add debounce =====
    const debounceTimeout = ref(null);
    const debouncedSearchContracts = (page=1) => {
      clearTimeout(debounceTimeout.value);
      debounceTimeout.value = setTimeout(() => {
        searchContracts(page);
      }, 1000); // triggers only after user stops typing for 500ms
    };
    onBeforeUnmount(() => {
      clearTimeout(debounceTimeout.value); // cleanup
    });
    // ===== End debounce =====

    const showAccordion = ref(false);
    const searchTerm = ref("");
    const selectedColumns = ref([]);
    const dropdown = ref(null);
    const moduleId = ref(null)
    const columnOptions = ref([]);

    const toggleAccordion = () => {
      showAccordion.value = !showAccordion.value;
    };

    const handleColumnSelection = (value) => {
      if (selectedColumns.value.value.includes(value)) {
        selectedColumns.value.value = selectedColumns.value.value.filter(col => col !== value);
      } else {
        selectedColumns.value.value.push(value);
      }
    };

    const filteredColumnOptions = computed(() => {
      if (!searchTerm.value) return columnOptions.value.value;
      return columnOptions.value.value.filter(option =>
        option.label.toLowerCase().includes(searchTerm.value.toLowerCase())
      );
    });

    const handleClickOutside = (event) => {
      if (dropdown.value && !dropdown.value.contains(event.target)) {
        showAccordion.value = false;
      }
    };

    const toggleSelectAllCM = async () => {
      if (isAllSelectedCm.value) {
        filters.value.cm_responsible = [];
      } else {
        filters.value.cm_responsible = filteredUsersCm.value.map((user) => user.id);
      }
      await searchContracts();
    };

    const toggleSelectAllU4b = async () => {
      if (isAllSelectedU4b.value) {
        filters.value.u4b_status = [];
      } else {
        filters.value.u4b_status = filteredUsersU4b.value.map((user) => user.value);
      }
      await searchContracts();
    };

    const toggleCheckboxCm = async (userId) => {
      const index = filters.value.cm_responsible.indexOf(userId);
      if (index === -1) {
        filters.value.cm_responsible.push(userId);
      } else {
        filters.value.cm_responsible.splice(index, 1);
      }
      await searchContracts();
    }

    const toggleCheckboxU4b = async (userId) => {
      const index = filters.value.u4b_status.indexOf(userId);
      if (index === -1) {
        filters.value.u4b_status.push(userId);
      } else {
        filters.value.u4b_status.splice(index, 1);
      }
      await searchContracts();
    }

    const fetchFilterOptions = async () => {
      const data = await store.dispatch('contract/fetchContractOptions');
      if (data?.module_id?.[0]?.id) {
        moduleId.value = data.module_id[0].id;
        u4bData.value = data.dropdowns.contract_u4b_status;
        const staticOption2 = {
          value: 'none',
          initials: 'No',
          text: 'None',
        };
        u4bData.value.unshift(staticOption2);
        filters.value.u4b_status = u4bData.value.map(user => user.value)
      }

      const territory_id = (route.query.ter_Id || '');
      cmData.value = data.cm_responsibles
      const staticOption = {
        id: 'none',
        initials: 'No',
        first_name: 'None',
        last_name: null
      };
      cmData.value.unshift(staticOption);
      filters.value.cm_responsible = cmData.value.map(user => user.id)
    }

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
    });

   onMounted(async () => {
      await fetchFilterOptions();
      await nextTick();

      const hasUserFilter = ['company_admin', 'territory_manager', 'cm_responsible']
        .some(role => user.value.roles.includes(role));

      if (!hasUserFilter) {
        searchContracts();
      }
    });

    return {
      searchQuery,
      contractsTable,
      filters,
      searchContracts,
      debouncedSearchContracts, // expose debounced version
      toggleFilter,
      isActive,
      showAccordion,
      searchTerm,
      selectedColumns,
      columnOptions,
      toggleAccordion,
      handleColumnSelection,
      filteredColumnOptions,
      dropdown,
      handleClickOutside,
      moduleId,
      searchCM,
      isAllSelectedCm,
      toggleSelectAllCM,
      checkedIdsCm,
      filteredUsersCm,
      cmData,
      searchU4b,
      isAllSelectedU4b,
      toggleSelectAllU4b,
      checkedIdsU4b,
      filteredUsersU4b,
      u4bData,
      fetchFilterOptions,
      toggleCheckboxCm,
      toggleCheckboxU4b,
      user,
      shouldPassFilter,
      filteredFilters
    }
  }
};
</script>

<style>
.form-select-height {
  line-height: 1.5 !important;
}

.filter-lable {
  margin-left: 5px;
  font-size: 12px !important;
}

/* .custom-table {
  height: 850px;
  overflow-x: hidden;
}

.filter-btn {
  position: relative;
}

.filter-drop-down {
  width: 350px;
  z-index: 9999;
  position: absolute;
  top: 90%;
  left: -160%;
}

.filter-set-contents .filter-content-list ul {
  max-height: 280px !important;
}

.toggle-btn {
  background-color: transparent !important;
  border: none !important;
  font-weight: 500 !important;
}

.disabled-checkbox {
  opacity: 0.6;
}

.disabled-label {
  cursor: not-allowed;
  pointer-events: none;
} */

.dropdown-menu.show {
  width: 250px;
}

ul.user_list {
  max-height: 295px;
  overflow-x: hidden;

}

.dropdown .dropdown-toggle:after {
  content: '';
}
</style>
